import { gql, MutationHookOptions, useMutation } from "@apollo/client";

export interface ExportBusinessAssetsMutationVariables {
  email: string;
  reportType: "DETAILED" | "SUMMARY";
  fileFormat: "CSV" | "PDF";
  year: number;
  withReceipts?: boolean;
}

export interface ExportBusinessAssetsMutationResult {
  exportBusinessAssets: {
    archive: string;
    archiveName: string;
    fileName: string;
  };
}

export const EXPORT_BUSINESS_ASSETS_MUTATION = gql`
  mutation exportBusinessAssets(
    $email: String!
    $reportType: BusinessAssetReportType!
    $fileFormat: BusinessAssetExportFileFormat!
    $year: Int!
    $withReceipts: Boolean
  ) {
    exportBusinessAssets(
      email: $email
      reportType: $reportType
      fileFormat: $fileFormat
      year: $year
      withReceipts: $withReceipts
    ) {
      archive
      fileName
      archiveName
    }
  }
`;

export const useExportBusinessAssetsMutation = (
  options?: MutationHookOptions<
    ExportBusinessAssetsMutationResult,
    ExportBusinessAssetsMutationVariables
  >
) =>
  useMutation<
    ExportBusinessAssetsMutationResult,
    ExportBusinessAssetsMutationVariables
  >(EXPORT_BUSINESS_ASSETS_MUTATION, options);
